<template>
    <div id="SuccessDiv">
        <HeaderVue isHealthCartEnabled="true" isHeader="true"/>
        <div class="search-section">
            <div id="message1" class="alert alert-success alert-dismissable flyover flyover-centered">
                <!-- <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button> -->
                <strong><i class="fa fa-check mr-2"></i></strong> Thank you for your Feedback
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="check-box float-left mr-3">
                            <img src="static/images/check.png" class="mt-2" alt="">
                        </div>
                        <div class="float-left thank-msg">
                            <h5 class="mb-0 white-color mt-3">
                                Thank you, your order has been placed successfully!
                               
                            </h5>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <p>
                            Our phlebotomist will get in touch with you at the phone number that you have provided before
                            coming to collect the sample at the address mentioned.
                        </p>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-light mar-3" v-on:click="gomyResult()">
                            My Result
                           <!-- <router-link to="/myresult">My Orders</router-link>    -->
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- search-section -->
        <div class="portal-section pt-3 pb-3" v-if="requestDetails">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="label-data">
                            <p>
                                Requested ID
                            </p>
                            <p>
                                {{'REQ'+requestDetails.requestId}}
                            </p>
                        </div>
                        <div class="label-data">
                            <p>
                                Patient Name
                            </p>
                            <p>
                               {{requestDetails.reqPatientFirstName+' '+requestDetails.reqPatientLastName}}
                            </p>
                        </div>
                        <div class="label-data">
                            <p>
                                Appointment Date & Time
                            </p>
                            <div class="green-outline">
                                {{appointmentDate}}&nbsp;&nbsp;|&nbsp;&nbsp;{{appointmentStartTime}} to {{appointmentEndTime}}
                            </div>
                        </div>
                        <div class="label-data">
                            <p>
                                Sample Collection Address
                            </p>
                            <p>
                                {{requestDetails.pickupAddress}}
                                <br/>M: {{requestDetails.reqPatientMobile}}
                            </p>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="lab display-flex no-border p-0 mt-3 bg-tranparent">
                            <div class="flex-box">
                                <div class="lab-logo">
                                     <img v-if="requestDetails.Lab.logo" :src="$s3BucketUrl + requestDetails.Lab.logo" />
                                </div>
                            </div>
                            <div class="flex-box">
                                <p class="black-color font-weight-bold mb-2">
                                    {{requestDetails.Lab.labName}}
                                    {{requestDetails.Lab.Address.Location.locationName}}, {{requestDetails.Lab.Address.City.cityName}}, {{requestDetails.Lab.Address.State.stateName}} - {{requestDetails.Lab.Address.zipCode}}
                                </p>
                                <!-- <a class="text-uppercase font-weight-bold" href="">
                                    Change Lab
                                </a> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 gray-bg">
                        <div class="table-responsive summary-table test-conformation">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th class="no-border">
                                            Test Name
                                        </th>
                                        <th class="text-right no-border">

                                        </th>
                                        <th class="no-border text-right">
                                            Price
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="black-color">
                                    <tr v-for="(requestTest, index) in requestDetails.RequestTests" :key='index'>
                                        <td  v-if="requestTest">
                                          <span>{{requestTest.Profile?(requestTest.Profile.panelName):(requestTest.Test.testName)}}</span>
                                        </td>
                                        <td>

                                        </td>
                                        <td>
                                            <p class="float-right mt-1 mb-0 price-tag">
                                                <!-- <span class="red-color strip-text">Rs. {{requestTest.testCost}} </span> -->
                                                Rs. {{requestTest.testCost}}
                                            </p>
                                        </td>
                                    </tr>
                                
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 border-bottom">
                        <div class="table-responsive">
                            <table class="table price-table">
                                <tbody>
                                    <tr v-if="requestDetails.phlebCost && requestDetails.phlebCost > 0">
                                        <td>
                                            Phlebotomist Fee
                                        </td>
                                        <td class="text-right">
                                           + Rs. {{requestDetails.phlebCost}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                          Sub total
                                        </td>
                                        <td class="text-right">
                                            Rs. {{(requestDetails.cost-requestDetails.discountCost) + (requestDetails.phlebCost && requestDetails.phlebCost > 0 ? requestDetails.phlebCost : 0)}}
                                        </td>
                                    </tr>
                                    <tr v-if="requestDetails.couponCost">
                                        <td>
                                            Coupon Discount
                                        </td>
                                        <td class="green-color text-right">
                                           - Rs.{{requestDetails.couponCost}}
                                        </td>
                                    </tr>
                                    <tr v-if="requestDetails.creditDiscount && requestDetails.creditDiscount > 0">
                                        <td>
                                            Credits Applied
                                        </td>
                                        <td class="green-color text-right">
                                           - Rs.{{requestDetails.creditDiscount}}
                                        </td>
                                    </tr>
                                    <tr v-if="requestDetails.paymentType == 1">
                                        <td class="black-color">
                                            Cash Due
                                        </td>
                                        <td class="text-right black-color">
                                            Rs. {{requestDetails.totalUnpaidCost}}
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td class="black-color">
                                            Amount Paid
                                        </td>
                                        <td class="text-right black-color">
                                            Rs. {{requestDetails.totalPaidCost}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 mt-4">
                        <button class="btn btn-outline-primary" v-on:click="goHome()">
                            Go to Homepage
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div class="alert feedback-form alert-secondary" role="alert">
                <div class="request-feedback">
                    <button class="btn btn-outline-primary full-width white-bg" data-toggle="modal" data-target="#feedback">
                        Request Your Feedback
                    </button>
                    <p class="mt-2">
                        Your feedback will help us bring you an even better experience!
                    </p>
                </div>
                <div class="feedback-thankyou" style="display:none">
                    <h4 class="text-center pt-5 pb-5">Thank you for your Feedback!</h4>
                </div>
            </div> -->
        </div>
        <!-- <div class="contact-info">
            <div class="container">
              <ul class="row text-center">
                  
                  <li>
                      <span class="sprites sprite-mail align-center"></span>
                      <p><a href="mailto:support@labotist.com" target="_top"> support@labotist.com </a></p>
                  </li>
                  <li>
                      <span class="sprites sprite-call align-center"></span>
                      <p><a href="tel:+919025662566">+91 90256 62566</a></p>
                  </li>
              </ul>
            </div>
        </div> -->
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
// import dateFormat from 'dateformat'

export default {
  name: 'SuccessRequest',
  props: ['sample'],
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
  },
  data () {
    return {
      requestDetails: {},
      s3BucketUrl: '',
      appointmentDate: '',
      appointmentStartTime: '',
      appointmentEndTime: ''
    }
  },
  methods: {
    gomyResult: function () {
      this.$router.push({path: '/myresult'})
    },
    getRequestDetails: function (requestId) {
      try {
        this.requestDetails = ''
        var data = {
          'requestId': requestId
        }
        Promise.resolve(this.$GET('patient/getRequestById', data)).then(function (res) {
          this.requestDetails = {}
          if (res.response_code === 0) {
            this.requestDetails = res.response
            this.s3BucketUrl = res.response.Lab.logo && res.response.Lab.logo.length > 0 ? this.$s3BucketUrl + res.response.Lab.logo : ''
            // if (res.response.appointmentDate) {
            //   var fromAppointment = (res.response.appointmentDate).split(' ')
            //   this.appointmentDate = res.response.appointmentDate ? dateFormat(fromAppointment[0]+'T'+fromAppointment[1], 'dd/mm/yyyy') : ''
            //   this.appointmentStartTime = res.response.appointmentDate ? dateFormat(fromAppointment[0]+'T'+fromAppointment[1], 'hh:MM') : ''
            // } else {
            //   this.appointmentDate = ''
            //   this.appointmentStartTime = ''
            // }
            
            // if (res.response.appointmentToDateTime) {
            //   var toAppointment = (res.response.appointmentToDateTime).split(' ')
            //   this.appointmentEndTime = res.response.appointmentToDateTime ? dateFormat(toAppointment[0] + 'T' + toAppointment[1], 'hh:MMtt') : ''
            // } else {
            //   this.appointmentEndTime = ''
            // }
            this.appointmentDate = ''
            this.appointmentStartTime = ''
            this.appointmentEndTime = ''
            if (res.response.appointmentDateDisp) {
              this.appointmentDate = res.response.appointmentDateDisp
            }
            if (res.response.appointmentFromTime) {
              this.appointmentStartTime = res.response.appointmentFromTime
            }
            if (res.response.appointmentToTime) {
              this.appointmentEndTime = res.response.appointmentToTime
            }
            this.clearRequestSessions()
          }
          this.$hidePageLoading()
        }.bind(this)).catch(function (err) {
          console.log(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    clearRequestSessions: function () {
      this.$localStorage.remove('pincode')
      this.$localStorage.remove('location')
      this.$localStorage.remove('st')
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('sa')
      this.$localStorage.remove('sm')
      this.$localStorage.remove('cou')
    },
    goHome: function () {
      this.$router.push({ path: '/' })
    }
  },
  created () {
    if (global.successId > 0) {
      this.getRequestDetails(global.successId)
      if (location.hostname === 'labotist.com') {
        gtag('event', 'conversion', {
          'send_to': 'AW-820857956/RXvTCLWFt3sQ5Ji1hwM',
          'value': this.requestDetails.totalPaidCost,
          'currency': 'INR',
          'transaction_id': ''
        })
      } else if (location.hostname === 'stage.labotist.com') {
        gtag('event', 'conversion', {
          'send_to': 'AW-819702604/tIrbCLnhwXsQzNbuhgM',
          'value': this.requestDetails.totalPaidCost,
          'currency': 'INR',
          'transaction_id': ''
        })
        console.log(gtag)
      }
    } else {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mobile/Book/Secure/Success.vue